import { Text } from '@/components/text';
import { getLocationCountryName } from '@/lib/models/location/get-location-country-name';
import { getLocationNameWithCode } from '@/lib/models/location/get-location-name-with-code';
import { LocationModel } from '@/lib/models/location/types';
import { PortSequence } from '@/types';
import { tv } from '@/utils/styles';

export interface LineTimelineProps {
  lineLocations: LocationModel[];
  portSequence?: PortSequence[];
  showNumbers?: boolean;
}

const LineTimeline = ({ lineLocations, portSequence = [], showNumbers = true }: LineTimelineProps) => {
  const { base, portMarker, portLine, portItem } = styles();

  return (
    <div className={base()}>
      {lineLocations.map((location, index) => {
        const { name, code } = getLocationNameWithCode(location);
        const countryName = getLocationCountryName(location.countryCode);
        // Determine if the marker is highlighted
        const port = portSequence.find((p) => p.position === index);
        const shouldHighlightLine = !![...portSequence].slice(0, -1).find((p) => p.position === index);

        return (
          <div key={`port_${index}`} className={portItem()}>
            <span className={portMarker({ isActive: Boolean(port) })}>{port && showNumbers ? port.label : ''}</span>
            <span className={portLine({ isActive: shouldHighlightLine })} />
            <div className="flex-1">
              <Text variant="secondary" className="m-0">
                <b className="font-semibold">{code}</b> ({name})
              </Text>
              <Text variant="secondary" className="m-0 grid text-sm text-text-secondary">
                {countryName}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'h-full overflow-auto',
    scroller: '',
    portItem: 'relative mb-4 flex last:mb-0 [&_.bar]:last:hidden',
    portMarker: 'relative z-2 mr-4 grid h-6 w-6 place-items-center rounded-full bg-grey-200 text-sm text-grey-600',
    portLine: 'bar absolute left-[10px] top-5 z-1 h-full w-1 bg-grey-200',
  },
  variants: {
    isActive: {
      true: {
        portMarker: 'bg-lightBlue-600 text-white',
        portLine: 'bg-lightBlue-600',
      },
    },
  },
});

export { LineTimeline };
